import WRAP from "WRAP-JS";
import LegendFix from "../legend/LegendFix";
import {
  configFixDh,
  configFixLayer
} from "./config/ConfigFix";
import { MAP_ID_FIX } from "../../../store/MapContentsState";
import { getCycleDate } from "../../../Authorization";
import { COMMUNICATE_ERROR_MESSAGE_FIX, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD } from "../../../constants/ErrorMessage";

class Fix {
  static NAME = MAP_ID_FIX
  static FIX_NAME = Fix.makeContentsKey('FIX');
  static FIXN_NAME = Fix.makeContentsKey('FIXN');
  static RNAV_NAME = Fix.makeContentsKey('RNAV');
  static CONTENTS_VISIBLE_STATE_DEFAULT = {
    [Fix.FIX_NAME]: true,
    [Fix.FIXN_NAME]: true,
    [Fix.RNAV_NAME]: true,
  };

  contentsVisibleState = {...Fix.CONTENTS_VISIBLE_STATE_DEFAULT};

  tileIndex;
  dhFix;
  layerFix;
  ready = false;
  visible = false;

  constructor() {
    this.layerFix = new WRAP.Geo.Layer(Fix.FIX_NAME);
    this.layerFix.setVisible(false);
  }

  async initialize() {
    await this.initData();
    this.initLayer();
    this.ready = true;
  }

  initData() {

    this.dhFix = new WRAP.Data(configFixDh);
    return new Promise((resolve) => {
      this.dhFix.updated('index', ref => {
        if (ref && Array.isArray(ref)) {
          const cycleDate = getCycleDate();
          const target = ref.find(data => data.Cycledate === cycleDate);
          this.tileIndex = target?.Prefix;
        }
        if (this.tileIndex) {
          resolve();
        }
      }, () => {
        this.contentsDispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_FIX,
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
      });
    });

  }

  initLayer() {
    this.layerFix.configure(this.dhFix, configFixLayer);
    this.layerFix.set({
      index: this.tileIndex
    });

    this.layerFix.setAttributes({
      filter: this._visibleFilter.bind(this)
    });

    const displayToolTip = (geo) => {
      return geo.properties.ident;
    };
    this.layerFix.setTooltip(displayToolTip);
  }

  async drawLayer(visible) {
    if (!this.ready && visible) {
      await this.initialize();
    }
    this.setVisible(visible);
  }

  getLayer() {
    return [this.layerFix];
  }

  setVisible(visible, contents) {
    this.visible = visible;
    if (contents) {
      this.contentsVisibleState[contents] = visible;
      if (!this.ready) return;
      this.layerFix.invalidate();
    } else {
      if (!this.ready) return;
      if (visible) {
        this.layerFix.show();
      } else {
        this.layerFix.hide();
      }
    }
  }

  getLegend() {
    return {
      id: Fix.NAME,
      label: 'FIX',
      component: LegendFix,
      contents: this
    };
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  resetContentsVisibleState() {
    this.contentsVisibleState = {...Fix.CONTENTS_VISIBLE_STATE_DEFAULT};
  }

  _visibleFilter(feature) {
    return this.contentsVisibleState[ Fix.makeContentsKey(feature.properties.kind) ];
  }

  static makeContentsKey(kind) {
    return `${Fix.NAME}_${kind}`;
  }

  setContentsDispatcher(dispatcher) {
    this.contentsDispatcher = dispatcher;
  }
}

export default Fix;
